export const puntoVentaRoutesMap = {
  gestion: {
    path: '/puntoVenta/gestion',
    name: 'Gestión de Puntos Venta',
  },
  nuevo: {
    path: '/puntoVenta/nuevo',
    name: 'Nuevo Registro',
  },
  modificar: {
    path: `/puntoVenta/modificar`,
    name: 'Actualizar Registro',
  },
}
